import { render, staticRenderFns } from "./workwechat.vue?vue&type=template&id=d459abee&scoped=true"
import script from "./workwechat.vue?vue&type=script&lang=js"
export * from "./workwechat.vue?vue&type=script&lang=js"
import style0 from "./workwechat.vue?vue&type=style&index=0&id=d459abee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d459abee",
  null
  
)

export default component.exports